var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.settings.form_theme === "material_design"
    ? _c(
        "div",
        {
          directives: [
            {
              name: "sticky",
              rawName: "v-sticky",
              value: { zIndex: 101, stickyTop: 5, parent: ".row" },
              expression: "{ zIndex: 101, stickyTop: 5, parent: '.row' }"
            }
          ]
        },
        [
          _c("div", { staticClass: "oc-form-preview" }, [
            _c("div", { staticClass: "form-zagl" }, [
              _vm._v(_vm._s(_vm.settings.form_title))
            ]),
            _vm._v(" "),
            _c(
              "form",
              { staticClass: "oc-form", attrs: { action: "", method: "post" } },
              [
                _c(
                  "div",
                  { staticClass: "form-body" },
                  [
                    !!_vm.settings.form_text || !!_vm.settings.photo
                      ? _c("div", { staticClass: "oc-form__field top-field" }, [
                          !!_vm.settings.photo
                            ? _c("div", { staticClass: "oc-img" }, [
                                _c("div", { staticClass: "oc-img__img" }, [
                                  _c("img", {
                                    attrs: { src: _vm.settings.photo, alt: "" }
                                  })
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.settings.form_text
                            ? _c("div", {
                                staticClass: "oc-text",
                                domProps: {
                                  innerHTML: _vm._s(_vm.settings.form_text)
                                }
                              })
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.settings.form_fields, function(field, index) {
                      return [
                        field.type == "topic"
                          ? _c(
                              "div",
                              { key: index, staticClass: "oc-form__field" },
                              [
                                _c(
                                  "select",
                                  {
                                    staticClass: "oc-form__control",
                                    attrs: {
                                      name: "oc[topic]",
                                      title: "",
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("option", [
                                      _vm._v("Выберите тему обращения")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.settings.form_topics, function(
                                      item,
                                      index
                                    ) {
                                      return item.active
                                        ? _c(
                                            "option",
                                            {
                                              key: index,
                                              domProps: { value: item.topic }
                                            },
                                            [_vm._v(_vm._s(item.topic))]
                                          )
                                        : _vm._e()
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "not-empty" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { staticClass: "oc-form__field-title" },
                                  [
                                    _vm._v("Тема обращения\n\t\t\t\t\t\t\t\t"),
                                    !!+field.required
                                      ? _c("span", { staticClass: "r_star" }, [
                                          _vm._v("*")
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          : field.type == "text_name"
                            ? _c(
                                "div",
                                { key: index, staticClass: "oc-form__field" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "not-empty",
                                        rawName: "v-not-empty"
                                      }
                                    ],
                                    staticClass: "oc-form__control",
                                    attrs: {
                                      type: "text",
                                      name: "oc[text_name]",
                                      title: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticClass: "oc-form__field-title" },
                                    [
                                      _vm._v("Имя\n\t\t\t\t\t\t\t\t"),
                                      !!+field.required
                                        ? _c(
                                            "span",
                                            { staticClass: "r_star" },
                                            [_vm._v("*")]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            : field.type == "tel"
                              ? _c(
                                  "div",
                                  { key: index, staticClass: "oc-form__field" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "not-empty",
                                          rawName: "v-not-empty"
                                        }
                                      ],
                                      staticClass: "oc-form__control",
                                      attrs: {
                                        type: "tel",
                                        name: "oc[tel]",
                                        title: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "oc-form__field-title" },
                                      [
                                        _vm._v("Телефон\n\t\t\t\t\t\t\t\t"),
                                        !!+field.required
                                          ? _c(
                                              "span",
                                              { staticClass: "r_star" },
                                              [_vm._v("*")]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              : field.type == "email"
                                ? _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "oc-form__field"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "not-empty",
                                            rawName: "v-not-empty"
                                          }
                                        ],
                                        staticClass: "oc-form__control",
                                        attrs: {
                                          type: "email",
                                          name: "oc[email]",
                                          title: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { staticClass: "oc-form__field-title" },
                                        [
                                          _vm._v("E-mail\n\t\t\t\t\t\t\t\t"),
                                          !!+field.required
                                            ? _c(
                                                "span",
                                                { staticClass: "r_star" },
                                                [_vm._v("*")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                : field.type == "comment"
                                  ? _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "oc-form__field"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "not-empty",
                                              rawName: "v-not-empty"
                                            }
                                          ],
                                          staticClass: "oc-form__control",
                                          attrs: {
                                            type: "text",
                                            name: "oc[comment]",
                                            title: ""
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "oc-form__field-title"
                                          },
                                          [
                                            _vm._v(
                                              "Комментарий\n\t\t\t\t\t\t\t\t"
                                            ),
                                            !!+field.required
                                              ? _c(
                                                  "span",
                                                  { staticClass: "r_star" },
                                                  [_vm._v("*")]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  : field.type == "checkbox"
                                    ? _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass:
                                            "oc-form__field oc-form__field_checkbox oc-form__field-untitled"
                                        },
                                        [
                                          _c(
                                            "label",
                                            [
                                              _c("checkbox", {
                                                staticClass:
                                                  "oc-light-form-checkbox",
                                                attrs: {
                                                  checked: field.is_checked
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "oc-form__field-title_text",
                                                domProps: {
                                                  innerHTML: _vm._s(field.text)
                                                }
                                              }),
                                              _vm._v(" "),
                                              !!+field.required
                                                ? _c(
                                                    "span",
                                                    { staticClass: "r_star" },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : field.type == "text_html"
                                      ? _c("div", {
                                          key: index,
                                          staticClass:
                                            "oc-form__field oc-form__field_text oc-form__field-untitled",
                                          domProps: {
                                            innerHTML: _vm._s(field.text)
                                          }
                                        })
                                      : _vm._e()
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "hidden",
                    name: "url",
                    value: "http://webasyst/"
                  }
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-accept",
                    style: {
                      color: _vm.settings.form_color_text,
                      background: _vm.settings.form_color_button,
                      opacity: this.settings.form_color_button_opacity
                    },
                    attrs: { href: "#/ordercall" }
                  },
                  [_vm._v(_vm._s(_vm.settings.form_button))]
                )
              ]
            )
          ])
        ]
      )
    : _vm.settings.form_theme === "light"
      ? _c(
          "div",
          {
            directives: [
              {
                name: "sticky",
                rawName: "v-sticky",
                value: { zIndex: 101, stickyTop: 5, parent: ".row" },
                expression: "{ zIndex: 101, stickyTop: 5, parent: '.row' }"
              }
            ]
          },
          [
            _c("div", { staticClass: "oc-light-form" }, [
              _c("svg", { attrs: { width: "0", height: "0" } }, [
                _c("defs", [
                  _c("path", {
                    attrs: {
                      id: "oc-light-form-checkbox-arrow",
                      d:
                        "M 4.5 8.41L 0 3.91L 1.41 2.5L 4.5 5.58L 10.09 0L 11.5 1.41L 4.5 8.41Z"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "oc-light-form__content" },
                [
                  _c("span", { staticClass: "oc-light-form__close-button" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "oc-light-form__header" }, [
                    _vm._v(_vm._s(_vm.settings.form_title))
                  ]),
                  _vm._v(" "),
                  _vm.settings.form_text || _vm.settings.photo
                    ? _c("div", { staticClass: "oc-light-form__text-box" }, [
                        _vm.settings.photo
                          ? _c(
                              "div",
                              { staticClass: "oc-light-form__image-box" },
                              [
                                _c("img", {
                                  staticClass: "oc-light-form__image",
                                  attrs: { src: _vm.settings.photo, alt: "" }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.settings.form_text
                          ? _c("div", {
                              staticClass: "oc-light-form__text",
                              domProps: {
                                innerHTML: _vm._s(_vm.settings.form_text)
                              }
                            })
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.settings.form_fields, function(field, index) {
                    return [
                      field.type == "topic"
                        ? _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "oc-light-form__field oc-light-form-field",
                              class: {
                                "oc-light-form-field_required": !!+field.required
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "oc-light-form-field__label" },
                                [_vm._v("Тема обращения")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "oc-light-form-field__box" },
                                [
                                  _c(
                                    "select",
                                    {
                                      staticClass: "oc-light-form-select",
                                      attrs: { name: "oc[topic]" }
                                    },
                                    [
                                      _c("option", [
                                        _vm._v("- Выберите тему обращения -")
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.settings.form_topics, function(
                                        item,
                                        index
                                      ) {
                                        return item.active
                                          ? _c(
                                              "option",
                                              {
                                                key: index,
                                                domProps: { value: item.topic }
                                              },
                                              [_vm._v(_vm._s(item.topic))]
                                            )
                                          : _vm._e()
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            ]
                          )
                        : field.type == "text_name"
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "oc-light-form__field oc-light-form-field",
                                class: {
                                  "oc-light-form-field_required": !!+field.required
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "oc-light-form-field__label" },
                                  [_vm._v("Имя")]
                                ),
                                _vm._v(" "),
                                _vm._m(0, true)
                              ]
                            )
                          : field.type == "tel"
                            ? _c(
                                "div",
                                {
                                  key: index,
                                  staticClass:
                                    "oc-light-form__field oc-light-form-field",
                                  class: {
                                    "oc-light-form-field_required": !!+field.required
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "oc-light-form-field__label"
                                    },
                                    [_vm._v("Телефон")]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(1, true)
                                ]
                              )
                            : field.type == "email"
                              ? _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "oc-light-form__field oc-light-form-field",
                                    class: {
                                      "oc-light-form-field_required": !!+field.required
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "oc-light-form-field__label"
                                      },
                                      [_vm._v("E-mail")]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(2, true)
                                  ]
                                )
                              : field.type == "comment"
                                ? _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "oc-light-form__field oc-light-form-field",
                                      class: {
                                        "oc-light-form-field_required": !!+field.required
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "oc-light-form-field__label"
                                        },
                                        [_vm._v("Комментарий")]
                                      ),
                                      _vm._v(" "),
                                      _vm._m(3, true)
                                    ]
                                  )
                                : field.type == "checkbox"
                                  ? _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "oc-light-form__field oc-light-form-field"
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "oc-light-form-checkbox-box"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "oc-light-form-checkbox-box__checkbox"
                                              },
                                              [
                                                _c("checkbox", {
                                                  staticClass:
                                                    "oc-light-form-checkbox",
                                                  attrs: {
                                                    checked: field.is_checked
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "oc-light-form-checkbox-box__label",
                                              domProps: {
                                                innerHTML: _vm._s(field.text)
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  : field.type == "text_html"
                                    ? _c("div", {
                                        key: index,
                                        staticClass:
                                          "oc-light-form__field oc-light-form-field",
                                        domProps: {
                                          innerHTML: _vm._s(field.text)
                                        }
                                      })
                                    : _vm._e()
                    ]
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "oc-light-form-button oc-light-form__submit-button",
                      style: {
                        color: _vm.settings.form_color_text,
                        background: _vm.settings.form_color_button,
                        opacity: this.settings.form_color_button_opacity
                      }
                    },
                    [_vm._v(_vm._s(_vm.settings.form_button))]
                  )
                ],
                2
              )
            ])
          ]
        )
      : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "oc-light-form-field__box" }, [
      _c("input", {
        staticClass: "oc-light-form-input-text",
        attrs: { type: "text", name: "oc[text_name]" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "oc-light-form-field__box" }, [
      _c("input", {
        staticClass: "oc-light-form-input-text",
        attrs: { type: "text", name: "oc[tel]" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "oc-light-form-field__box" }, [
      _c("input", {
        staticClass: "oc-light-form-input-text",
        attrs: { type: "text", name: "oc[email]" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "oc-light-form-field__box" }, [
      _c("textarea", {
        staticClass: "oc-light-form-textarea",
        attrs: { name: "oc[comment]" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07e6383c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e6383c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/form/FormViewer2.vue
// module id = 121
// module chunks = 0